import { testId } from '../utils';
import { Typography } from './primitives';
import { Cornerstone } from '@rpi/api';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

type AddressDisplayProps = {
  'data-testid': string;
  address: Cornerstone.ValueAddress;
};

export const AddressDisplay: React.FC<AddressDisplayProps> = ({
  address,
  'data-testid': dataTestId,
}) => {
  const { i18n } = useTranslation();

  const regionNames = new Intl.DisplayNames([i18n.language], {
    type: 'region',
  });

  return (
    <div className="flex flex-col" {...testId(dataTestId)}>
      <Typography variant="body">{`${address.firstName} ${address.lastName}`}</Typography>
      <Typography variant="body">{address.addressLine1}</Typography>
      <Typography variant="body">{`${address.city}, ${address.regionIsoCode} ${address.postalCode}`}</Typography>
      <Typography variant="body">
        {regionNames.of(address.countryIso)}
      </Typography>
      <Typography variant="body">{address.phone}</Typography>
    </div>
  );
};
